import React from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import VasimCard from './Components/VasimCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import './VasimBlock.scss';

const VasimBlock = ({context, iContent}) => {
  const header = iContent.header?.value;
  const showMainButton = iContent.showMainButton?.value;
  const mainButtonText = iContent.mainButtonText?.value;
  const mainButtonLink = iContent.mainButtonLink?.expandedValue?.url;
  const cards = iContent.cards?.expandedValue;

  const handleButtonClick = () => {
    if (mainButtonLink) {
      window.location.href = mainButtonLink;
    }
  };

  const isMobile = typeof window !== 'undefined' ? window.innerWidth < 769 : false;

  return (
    <div className="vasim-block">
      {header && (
        <div className="vasim-block__header" dangerouslySetInnerHTML={{ __html: header }} />
      )}

      <div className="cards-and-btn">
        <div className="carousel-cards">
          {isMobile ? (
            <Swiper
              slidesPerView={'auto'}
              spaceBetween={6}
              dir="rtl"
              className="vasim-swiper"
            >
              {cards && cards.map((card, index) => (
                <SwiperSlide key={index} className="vasim-swiper-slide">
                  <VasimCard card={card} context={context} />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            cards && cards.map((card, index) => (
              <VasimCard key={index} card={card} context={context} />
            ))
          )}
        </div>

        {showMainButton && mainButtonLink && mainButtonText && (
          <BtnSubmit className="secondary-btn" text={mainButtonText} onclick={handleButtonClick} />
        )}
      </div>
    </div>
  );
};

export default VasimBlock;

